<template>
    <!-- Container para toda la página: ******************************************************* -->
    <v-container fill-height fluid class="answersets">
        <!-- Layout para toda la página: *********************************************************** -->
        <v-layout align-center justify-center>
            <!-- Flex para la ventana: **************************************************************** -->
            <v-flex xs12 sm11 elevation-6>
                <div class="sub-window">
                    <v-toolbar dense dark color="teal darken-3">
                        <v-toolbar-title>Sets de Respuestas&nbsp;&nbsp;</v-toolbar-title>
                        <v-text-field
                            :disabled="bEdit"
                            hide-details
                            single-line
                            v-model="searchText"
                        ></v-text-field>
                        <v-btn :disabled="bEdit" small icon @click="onSearch">
                            <v-icon>mdi-magnify</v-icon>
                        </v-btn>
                        <v-spacer></v-spacer>
                        <v-toolbar-items class="hidden-sm-and-down">
                            <v-btn
                                :disabled="bEdit"
                                text
                                class="text-none"
                                @click="onNewSet"
                            >Nuevo Set</v-btn>
                            <v-btn
                                :disabled="(bEdit || answerSetID === 0 )"
                                text
                                class="text-none"
                                @click="onEditAnswerSet"
                            >Editar Set</v-btn>
                            <v-btn
                                :disabled="(bEdit || answerSetID === 0 )"
                                text
                                class="text-none"
                                @click="onDeleteAnswerSet"
                            >Borrar Set</v-btn>

                            <v-menu offset-y>
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                        text
                                        :disabled="!bEdit"
                                        class="text-none"
                                        v-on="on"
                                    >Respuesta</v-btn>
                                </template>
                                <v-list color="grey lighten-5">
                                    <v-list-item @click="onNewAnswer">
                                        <v-list-item-title>
                                            <v-icon color="teal darken-1">mdi-comment-plus</v-icon>&nbsp; Nueva...
                                        </v-list-item-title>
                                    </v-list-item>
                                    <v-list-item
                                        @click="onEditAnswer"
                                        :disabled="selectedAnswer.length === 0"
                                    >
                                        <v-list-item-title>
                                            <v-icon
                                                color="teal darken-1"
                                                :disabled="selectedAnswer.length === 0"
                                            >mdi-comment-edit</v-icon>&nbsp; Editar...
                                        </v-list-item-title>
                                    </v-list-item>
                                    <v-list-item
                                        @click="onDeleteAnswer"
                                        :disabled="selectedAnswer.length === 0"
                                    >
                                        <v-list-item-title>
                                            <v-icon
                                                color="teal darken-1"
                                                :disabled="selectedAnswer.length === 0"
                                            >mdi-comment-remove</v-icon>&nbsp; Borrar
                                        </v-list-item-title>
                                    </v-list-item>
                                </v-list>
                            </v-menu>

                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-btn text :disabled="bEdit" @click="onClose" v-on="on">
                                        <v-icon>mdi-close</v-icon>
                                    </v-btn>
                                </template>
                                <span>Cerrar</span>
                            </v-tooltip>
                        </v-toolbar-items>

                        <!-- Menú lateral para dispositivos con ventanas chicas: -->
                        <v-menu offset-y>
                            <template v-slot:activator="{ on }">
                                <v-btn icon v-on="on" class="hidden-md-and-up">
                                    <v-icon>mdi-dots-vertical</v-icon>
                                </v-btn>
                            </template>
                            <v-list color="grey lighten-4">
                                <v-list-item :disabled="bEdit" @click="onNewSet">
                                    <v-list-item-title>
                                        <v-icon
                                            color="teal darken-1"
                                            :disabled="bEdit"
                                            @click="onNewSet"
                                        >mdi-file-plus</v-icon>&nbsp; Nuevo Set
                                    </v-list-item-title>
                                </v-list-item>
                                <v-list-item :disabled="bEdit" @click="onEditAnswerSet">
                                    <v-list-item-title>
                                        <v-icon
                                            color="teal darken-1"
                                            :disabled="bEdit"
                                            @click="onEditAnswerSet"
                                        >mdi-pencil</v-icon>&nbsp; Editar Set
                                    </v-list-item-title>
                                </v-list-item>
                                <v-list-item :disabled="bEdit" @click="onDeleteAnswerSet">
                                    <v-list-item-title>
                                        <v-icon
                                            color="teal darken-1"
                                            :disabled="bEdit"
                                            @click="onDeleteAnswerSet"
                                        >mdi-delete</v-icon>&nbsp; Borrar Set
                                    </v-list-item-title>
                                </v-list-item>
                                <v-divider></v-divider>
                                <v-list-item :disabled="!bEdit" @click="onNewAnswer">
                                    <v-list-item-title>
                                        <v-icon
                                            color="teal darken-1"
                                            :disabled="!bEdit"
                                            @click="onNewAnswer"
                                        >mdi-comment-plus</v-icon>&nbsp; Nueva Respuesta...
                                    </v-list-item-title>
                                </v-list-item>
                                <v-list-item
                                    :disabled="!bEdit || selectedAnswer.length === 0"
                                    @click="onEditAnswer"
                                >
                                    <v-list-item-title>
                                        <v-icon
                                            color="teal darken-1"
                                            :disabled="!bEdit || selectedAnswer.length === 0"
                                        >mdi-comment-edit</v-icon>&nbsp; Editar Respuesta...
                                    </v-list-item-title>
                                </v-list-item>
                                <v-list-item
                                    :disabled="!bEdit || selectedAnswer.length === 0"
                                    @click="onDeleteAnswer"
                                >
                                    <v-list-item-title>
                                        <v-icon
                                            color="teal darken-1"
                                            :disabled="!bEdit || selectedAnswer.length === 0"
                                        >mdi-comment-plus</v-icon>&nbsp; Borrar Respuesta
                                    </v-list-item-title>
                                </v-list-item>
                                <v-divider></v-divider>
                                <v-list-item :disabled="bEdit" @click="onClose">
                                    <v-list-item-title>
                                        <v-icon
                                            color="red"
                                            :disabled="bEdit"
                                            @click="onClose"
                                        >mdi-close</v-icon>&nbsp; Cerrar
                                    </v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </v-toolbar>

                    <!-- Container para lista de sets de respuestas y set seleccionado: -->
                    <v-container pa-2 grid-list-md fluid>
                        <!-- Renglón único para lista de sets de respuestas y card de set seleccionado: -->
                        <v-layout row wrap justify-space-around>
                            <!-- Lista de sets de respuestas: *************************** -->
                            <v-flex xs10 sm4 md3>
                                <v-card>
                                    <v-toolbar dense color="teal darken-1" dark flat>
                                        <v-toolbar-title
                                            class="my-list-title"
                                        >Sets de Respuestas Registrados</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-format-list-bulleted</v-icon>
                                    </v-toolbar>

                                    <v-list
                                        subheader
                                        dense
                                        :height="listHeight"
                                        max-height="100%"
                                        class="overflow-y-auto"
                                        :disabled="bEdit"
                                        color="grey lighten-4"
                                    >
                                        <v-list-item-group
                                            v-model="selectedAnswerSetIndex"
                                            color="orange accent-4"
                                            :mandatory="!bNew"
                                        >
                                            <v-list-item
                                                class="my-list-item"
                                                v-for="(answerset, i) in answerSets"
                                                :key="i"
                                                @click="selectAnswerSet(answerset.setrespuestasid)"
                                            >
                                                <v-list-item-content>
                                                    <v-list-item-title>
                                                        <v-container pa-0 fluid>
                                                            <v-layout row wrap>
                                                                <v-flex
                                                                    md2
                                                                    xs6
                                                                >{{ answerset.nombre }}</v-flex>
                                                            </v-layout>
                                                        </v-container>
                                                    </v-list-item-title>
                                                </v-list-item-content>
                                            </v-list-item>
                                        </v-list-item-group>
                                    </v-list>
                                </v-card>
                            </v-flex>

                            <!-- Termina Lista de Sets de Respuestas ********************************* -->

                            <!-- Info de set seleccionado: *********************** -->
                            <v-flex xs10 sm8 md9>
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="teal lighten-3" flat>
                                        <v-toolbar-title
                                            class="my-list-title"
                                        >{{ selectedAnswerSetName }}</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-check-all</v-icon>
                                    </v-toolbar>

                                    <v-card-text>
                                        <v-container fluid grid-list-xl>
                                            <v-layout row wrap justify-space-between>
                                                <v-flex xs12 md10>
                                                    <v-text-field
                                                        prepend-icon="mdi-check-all"
                                                        name="name"
                                                        label="Nombre del set de respuestas"
                                                        type="text"
                                                        v-model="name"
                                                        :readonly="!bEdit"
                                                        ref="name_field"
                                                        color="teal darken-3"
                                                    ></v-text-field>
                                                </v-flex>
                                            </v-layout>

                                            <v-layout row wrap>
                                                <v-flex xs4 md3 v-for="lang in languagesAnswerSet">
                                                    <v-checkbox
                                                        :readonly="!bEdit"
                                                        :key="lang.languageID"
                                                        :label="lang.language"
                                                        v-model="lang.selected"
                                                        color="orange accent-4"
                                                        dense
                                                        @change="onSelectLanguage(lang.languageID)"
                                                    ></v-checkbox>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row wrap>
                                                <v-flex xs12>
                                                    <v-card>
                                                        <v-card-title
                                                            class="teal--text text--darken-3"
                                                        >Respuestas</v-card-title>

                                                        <v-data-table
                                                            fixed-header
                                                            :headers="answerTableHeader"
                                                            :items="answerTable"
                                                            item-key="valoressetrespuestasid"
                                                            v-model="selectedAnswer"
                                                            locale="es-MX"
                                                            hide-default-footer
                                                            no-data-text="No hay respuestas para el set seleccionado."
                                                            :show-select="bEdit"
                                                            single-select
                                                            dense
                                                        ></v-data-table>
                                                    </v-card>
                                                </v-flex>
                                            </v-layout>

                                            <!-- v-if="(bEdit && $vuetify.breakpoint.smAndUp)" -->
                                            <v-layout
                                                v-if="bEdit"
                                                align-center
                                                justify-end
                                                row
                                                fill-height
                                            >
                                                <v-flex xs12 sm8 class="text-xs-center text-end">
                                                    <v-btn
                                                        color="teal darken-3"
                                                        class="text-none"
                                                        text
                                                        @click="onSave"
                                                        :disabled="!bEdit"
                                                    >OK</v-btn>
                                                    <v-btn
                                                        color="pink darken-1"
                                                        class="text-none"
                                                        text
                                                        @click="onCancel"
                                                        :disabled="!bEdit"
                                                    >Cancelar</v-btn>
                                                </v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-card-text>
                                </v-card>
                            </v-flex>
                            <!-- Termina info de Set de Respuestas seleccionado *********************** -->
                        </v-layout>

                        <!-- Modal para confirmar borrado de Set de Respuestas: **************************************** -->
                        <v-layout row justify-center>
                            <v-dialog v-model="bDeletingAnswerSet" persistent max-width="35%">
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="orange darken-2" dark flat>
                                        <v-toolbar-title
                                            class="my-list-title"
                                        >Borrar Set de Respuestas</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-icon>delete</v-icon>
                                    </v-toolbar>
                                    <v-card-title class="text-center">
                                        <div style="margin: auto">
                                            <v-icon large color="orange darken-2">warning</v-icon>
                                        </div>
                                        &nbsp; ¿Desea borrar el set de respuestas {{ selectedAnswerSetName }}?
                                    </v-card-title>
                                    <v-card-text
                                        class="text-center"
                                    >Esta acción no se puede deshacer.</v-card-text>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="deleteAnswerSetConfirmed"
                                        >OK</v-btn>
                                        <v-btn
                                            color="pink darken-1"
                                            class="text-none"
                                            text
                                            @click="cancelDeleteAnswerSet"
                                        >Cancelar</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina Modal para confirmar borrado de Set de Respuestas *************************** -->

                        <!-- Modal para confirmar borrado de Idioma: **************************************** -->
                        <v-layout row justify-center>
                            <v-dialog v-model="bDlgDeletingLanguage" persistent max-width="35%">
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="orange darken-3" dark flat>
                                        <v-toolbar-title class="my-list-title">Quitar Idioma</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-translate</v-icon>
                                    </v-toolbar>
                                    <v-card-title class="text-center">
                                        <div style="margin: auto">
                                            <v-icon large color="orange darken-3">mdi-earth-off</v-icon>
                                        </div>
                                        &nbsp; ¿Desea borrar las respuestas en {{ selectedLanguage }}?
                                    </v-card-title>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="deleteLanguageConfirmed"
                                        >OK</v-btn>
                                        <v-btn
                                            color="pink darken-1"
                                            class="text-none"
                                            text
                                            @click="cancelDeleteLanguage"
                                        >Cancelar</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina Modal para confirmar borrado de Idioma *************************** -->

                        <!-- Modal para confirmar agregar Idioma: **************************************** -->
                        <v-layout row justify-center>
                            <v-dialog v-model="bDlgAddingLanguage" persistent max-width="35%">
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="teal lighten-3" flat>
                                        <v-toolbar-title class="my-list-title">Agregar Idioma</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-translate</v-icon>
                                    </v-toolbar>
                                    <v-card-title class="text-center">
                                        <div style="margin: auto">
                                            <v-icon large color="teal darken-3">mdi-earth</v-icon>
                                        </div>
                                        &nbsp; ¿Desea agregar respuestas en {{ selectedLanguage }}?
                                    </v-card-title>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="addLanguageConfirmed"
                                        >OK</v-btn>
                                        <v-btn
                                            color="pink darken-1"
                                            class="text-none"
                                            text
                                            @click="cancelAddLanguage"
                                        >Cancelar</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina Modal para confirmar agregar Idioma *************************** -->

                        <!-- Modal para editar una respuesta: **************************************** -->
                        <v-layout row justify-center>
                            <v-dialog v-model="bDlgEditAnswer" persistent max-width="50%">
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="teal lighten-3" flat>
                                        <v-toolbar-title
                                            class="my-list-title"
                                        >Editar Respuesta {{ selectedAnswerNumber }}</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-comment-edit</v-icon>
                                    </v-toolbar>
                                    <v-card-text>
                                        <v-container grid-list-md>
                                            <v-layout row>
                                                <v-flex xs4>
                                                    <v-text-field
                                                        prepend-icon="mdi-counter"
                                                        name="value"
                                                        label="Valor"
                                                        type="number"
                                                        required
                                                        v-model="selectedAnswerValue"
                                                        color="teal darken-3"
                                                    ></v-text-field>
                                                </v-flex>
                                            </v-layout>

                                            <v-layout row v-for="answer in editingAnswer">
                                                <v-flex xs12>
                                                    <v-text-field
                                                        dense
                                                        prepend-icon="mdi-text"
                                                        :label="answer.answerLanguageName"
                                                        type="text"
                                                        required
                                                        v-model="answer.respuesta"
                                                        color="teal darken-3"
                                                    ></v-text-field>
                                                </v-flex>
                                                <v-flex xs12>
                                                    <v-textarea
                                                        dense
                                                        outlined
                                                        v-model="answer.tooltip"
                                                        :auto-grow="false"
                                                        no-resize
                                                        rows="2"
                                                        prepend-icon="mdi-tooltip-text"
                                                        :label="answer.tooltipLanguageName"
                                                        type="text"
                                                        color="teal darken-3"
                                                    ></v-textarea>
                                                </v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-card-text>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="onConfirmAnswerEdition"
                                        >OK</v-btn>
                                        <v-btn
                                            color="pink darken-1"
                                            class="text-none"
                                            text
                                            @click="onCancelAnswerEdition"
                                        >Cancelar</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina Modal para editar una respuesta *************************** -->

                        <!-- Modal para informar que no hubo resultados en la búsqueda: *********************************** -->
                        <v-layout row justify-center>
                            <v-dialog v-model="bShowNotFoundAlert" persistent max-width="30%">
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="teal" dark flat>
                                        <v-toolbar-title
                                            class="my-list-title"
                                        >Búsqueda de Sets de Respuestas</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-icon>search</v-icon>
                                    </v-toolbar>
                                    <v-card-text>
                                        <v-container>
                                            <v-layout row>
                                                <v-flex xs12 class="d-flex justify-center">
                                                    <v-icon large color="orange darken-2">warning</v-icon>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row>
                                                <v-flex
                                                    xs12
                                                    class="d-flex justify-center"
                                                >No hay sets de respuestas registrados con ese nombre.</v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-card-text>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="bShowNotFoundAlert = false"
                                        >OK</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina modal para informar que no hubo resultados en la búsqueda *************************** -->
                        <!-- Modal para confirmar borrado de respuesta: **************************************** -->
                        <v-layout row justify-center>
                            <v-dialog v-model="bDeletingAnswer" persistent max-width="35%">
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="orange darken-2" dark flat>
                                        <v-toolbar-title class="my-list-title">Borrar Respuesta</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-comment-remove</v-icon>
                                    </v-toolbar>
                                    <v-card-title class="text-center">
                                        <div style="margin: auto">
                                            <v-icon large color="orange darken-2">mdi-alert</v-icon>
                                        </div>
                                        &nbsp; ¿Desea borrar la respuesta {{ selectedAnswerNumber }}?
                                    </v-card-title>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="deleteAnswerConfirmed"
                                        >OK</v-btn>
                                        <v-btn
                                            color="pink darken-1"
                                            class="text-none"
                                            text
                                            @click="cancelDeleteAnswer"
                                        >Cancelar</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina Modal para confirmar borrado de respuesta *************************** -->

                        <!-- Modal para pedir que se introduzcan todos los campos obligatorios: *********************************** -->
                        <v-layout row justify-center>
                            <v-dialog v-model="bInvalidData" persistent :width="errorModalWidth">
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="teal" dark flat>
                                        <v-toolbar-title
                                            class="my-list-title"
                                        >Información Incompleta</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-alert-circle-outline</v-icon>
                                    </v-toolbar>
                                    <v-card-title>
                                        <v-container>
                                            <v-layout row justify-center>
                                                <v-flex xs12 class="d-flex justify-center">
                                                    <v-icon
                                                        large
                                                        color="orange darken-2"
                                                    >mdi-alert-circle</v-icon>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row justify-center>
                                                <v-flex
                                                    xs11
                                                    class="justify-center text-center"
                                                >{{ errorMessage }}</v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-card-title>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="bInvalidData = false"
                                        >OK</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina modal para pedir que se introuzcan todos los campos *********************************** -->

                        <!-- Modal para informar que para agregar una respuesta debe haber por lo menos un idioma seleccionado: *********************************** -->
                        <v-layout row justify-center>
                            <v-dialog v-model="bDlgNoLanguageWarning" persistent max-width="30%">
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="teal" dark flat>
                                        <v-toolbar-title class="my-list-title">Agregar Respuesta</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-alert-circle</v-icon>
                                    </v-toolbar>
                                    <v-card-text>
                                        <v-container>
                                            <v-layout row>
                                                <v-flex xs12 class="d-flex justify-center">
                                                    <v-icon large color="orange darken-2">mdi-alert</v-icon>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row>
                                                <v-flex
                                                    xs12
                                                    class="d-flex justify-center"
                                                >Seleccione por lo menos un idioma.</v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-card-text>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="bDlgNoLanguageWarning = false"
                                        >OK</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>

                        <!-- Termina renglón único para lista de Sets de Respuestas y set seleccionado -->
                    </v-container>
                    <!-- Termina container para lista de Sets de Respuestas y set seleccionado -->
                </div>
            </v-flex>
            <!-- Fin Flex para la ventana **************************************************************** -->
        </v-layout>
        <!-- Fin Layout para toda la página *********************************************************** -->
        <v-overlay :value="waitCursor">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </v-container>
    <!-- Fin container para toda la página ********************************************* -->
</template>
<script>
import { mapGetters } from 'vuex';

export default {
    name: 'answersets',
    data() {
        return {
            drawer: false,
            bEdit: false,
            bNew: false,
            answerSetID: 0,
            name: '',

            bInvalidData: false,
            errorMessage: '',

            selectedAnswerSetName: '',
            bDeletingAnswerSet: false,
            //answers: [], //Respuestas del idioma seleccionado.
            //respuestas: [], //NUEVO, Respuestas del set de respuestas seleccionado.
            searchText: '',
            bShowNotFoundAlert: false, //Indica si se debe mostrar el diálogo que indica que no hubo resultados en la búsqueda.
            selectedAnswer: [], //Indica la respuesta seleccionada de la tabla.
            bDeletingAnswer: false,
            bDlgEditAnswer: false,

            bDlgDeletingLanguage: false,
            bDlgAddingLanguage: false,

            editingAnswer: [], //Arreglo con las respuesta seleccionada para edición, en todos los idiomas.

            //selectedAnswerTxt: '',
            selectedAnswerValue: 0,
            selectedAnswerID: 0,
            selectedAnswerNumber: 0,
            selectedLanguage: '', //Nombre del idioma seleccionado.
            languageToDelete: 0, //ID del lenguage desseleccionado.
            languageToAdd: 0, //ID del lenguage seleccionado para ser agregado.
            bDlgNoLanguageWarning: false,
        };
    },
    created() {
        this.selectFirstSet();
    },
    methods: {
        onClose() {
            this.$router.push('/');
        },
        onNewSet() {
            this.bEdit = true;
            this.bNew = true;
            this.selectedAnswerSetName = 'Nuevo Set de Respuestas';
            this.selectedAnswerSetIndex = -1;

            this.answerSetID = 0;
            this.name = '';

            this.$refs.name_field.focus();

            this.selectedAnswer = [];
            this.answers = [];
            this.languageAnswers = [];

            this.$store.dispatch('createAnswerSetLanguages');
        },
        onDeleteAnswerSet() {
            this.bDeletingAnswerSet = true;
        },
        cancelDeleteAnswerSet() {
            this.bDeletingAnswerSet = false;
        },
        deleteAnswerSetConfirmed() {
            this.bDeletingAnswerSet = false;

            //Como el borrado en el servidor es asíncrono, antes de borrar el registro en el servidor se borra
            //el registro localmente. Si no, si el registro borrado era el primer registro, si primero se
            //borra en el servidor y después se selecciona el primer registro, es posible que se vuelva a
            //seleccionar el registro borrado antes de que éste se borre en el servidor.

            var i;
            for (i = 0; i < this.answerSets.length; i++) {
                if (this.answerSets[i].setrespuestasid === this.answerSetID) {
                    this.answerSets.splice(i, 1);
                    break;
                }
            }

            this.$store.dispatch('deleteAnswerSet', this.answerSetID);
            this.selectFirstSet();
        },
        onEditAnswerSet() {
            this.bEdit = true;
            this.selectedAnswer = [];
        },
        onCancel() {
            if (this.bNew) {
                //Selecciona el primer set de respuestas de la lista:
                this.selectFirstSet();
                this.bNew = false;
            } else {
                //Vuelve a obtener todos los sets de respuestas:
                this.$store.dispatch('fetchAnswerSets');
                this.selectAnswerSet(this.answerSetID);
            }
            this.bEdit = false;
        },
        onSave() {
            var bDataOK = false;

            //Validación de los datos:

            if (this.name === '') {
                this.bInvalidData = true;
                this.errorMessage = 'El nombre del set de respuestas es obligatorio.';
            } else {
                //Busca que las respuestas en todos los idiomas seleccionados estén registradas:
                var i;
                for (i = 0; i < this.languageAnswers.length; i++) {
                    if (this.languageAnswers[i].respuesta === '') {
                        this.bInvalidData = true;
                        this.errorMessage = 'Por favor escriba todas las respuestas en todos los idiomas seleccionados.';
                        break;
                    }
                }
            }
            if (!this.bInvalidData) {
                bDataOK = true;
            }

            if (bDataOK) {
                //Se busca en el arreglo answerSets el set que corresponde al set que se está o editando o registrando (si se
                //está registrando uno nuevo, answerSetID es 0)

                //Edición de set de respuestas...
                var i;
                console.log('this.answerSets = ', this.answerSets);
                console.log('this.answerSetID = ', this.answerSetID);
                for (i = 0; i < this.answerSets.length; i++) {
                    //console.log('i = ', i);
                    if (this.answerSets[i].setrespuestasid === this.answerSetID)
                    {
                        this.answerSets[i].nombre = this.name;
                        break;
                    }
                }
                if (!this.bNew) {
                    //Edición del registro en la BD:
                    this.$store.dispatch('updateAnswerSet', this.answerSets[i]);
                } else if (this.bNew) {
                    //Registro de Nuevo Set de Respuestas...
                    this.bNew = false;

                    const newAnswerSet = {
                        nombre: this.name,
                    };

                    this.$store.dispatch('saveNewAnswerSet', newAnswerSet);
                }

                this.bEdit = false;
                this.selectedAnswerSetName = this.name;
            }
        },
        selectFirstSet() {
            //console.log('selectFistSet, ', this.answerSets);
            if (this.answerSets.length > 0) {
                this.selectedAnswerSetIndex = 0;
                var answerSetID = this.answerSets[this.selectedAnswerSetIndex]
                    .setrespuestasid;
                this.selectAnswerSet(answerSetID);
            } else {
                this.selectedAnswerSetIndex = -1;
                this.answerSetID = 0;
            }
        },
        selectAnswerSet(answerSetID) {
            var i;
            for (i = 0; i < this.answerSets.length; i++) {
                if (this.answerSets[i].setrespuestasid === answerSetID) {
                    this.answerSetID = answerSetID;
                    this.name = this.answerSets[i].nombre;
                    this.selectedAnswerSetName = this.name;

                    break;
                }
            }
            console.log('En SelectAnswerSet, answerSetID = ', answerSetID);
            this.$store.dispatch('getAnswerSetData', answerSetID);
        },

        onSelectLanguage(languageID) {
            //console.log('languagesAnswerSet = ', this.languagesAnswerSet);
            //console.log('languageID = ', languageID);

            this.bDlgDeletingLanguage = false;
            this.bDlgAddingLanguage = false;

            //Se recorre el primer elemento de la tabla AnswerTable, para ver si el idioma se seleccionó o se desseleccionó:
            var i;
            for (i = 0; i < this.answerTable.length; i++) {
                //Recorre todas las propiedades de cada objeto de answerTable, para ver si alguna propiedad es el idioma seleccionado.
                //Si es así, entonces el idioma ya estaba seleccionado antes y se debe desseleccionar.
                //Si el idioma se desseleccionó, hay que confirmar que se desea borrar todas las respuestas
                //para ese idioma. En la confirmación, hay que borrar en el arreglo languageAnswers todos los
                //objetos con idiomaid = languageID.
                //Después, hay que volver a generar el arreglo answerTable y el arreglo answerHeader.

                for (const prop in this.answerTable[i]) {
                    if (this.answerTable[i].hasOwnProperty(prop)) {
                        var strLanguageID = String(languageID);
                        if (prop === strLanguageID) {
                            //El idioma se encontró como una propiedad del objeto, lo que quiere decir que hay que desseleccionarlo:
                            var j;
                            for (j = 0; j < this.languages.length; j++) {
                                if (this.languages[j].idiomaid === languageID) {
                                    this.selectedLanguage = this.languages[
                                        j
                                    ].idioma;
                                    this.languageToDelete = languageID;
                                    this.bDlgDeletingLanguage = true;
                                    break;
                                }
                            }
                            break;
                        }
                    }
                }
                if (this.bDlgDeletingLanguage) {
                    break;
                }
            }

            //Si no se encontró el ID del idioma como una propiedad del objeto, quiere decir que hay que seleccionarlo:
            if (!this.bDlgDeletingLanguage) {
                //Hay que agregar un objeto languageAnswers con el idioma seleccionado para cada respuesta existente
                //del set de respuestas de la siguiente manera:
                //     {
                //         valoressetrespuestasid: uno para cada respuesta existente,
                //         idiomaid: languageID,
                //         respuesta: ''
                //     },
                //Después, hay que volver a generar el arreglo answerTable y el arreglo answerHeader.

                //Primero se pide confirmación para agregar el lenguage:

                this.languageToAdd = languageID;
                for (i = 0; i < this.languages.length; i++) {
                    if (this.languages[i].idiomaid === this.languageToAdd) {
                        this.selectedLanguage = this.languages[i].idioma;
                        break;
                    }
                }
                this.bDlgAddingLanguage = true;
            }
        },
        cancelDeleteLanguage() {
            this.bDlgDeletingLanguage = false;
            //Vuelve a seleccionar el lenguage desseleccionado:

            var i;
            for (i = 0; i < this.languagesAnswerSet.length; i++) {
                if (
                    this.languagesAnswerSet[i].languageID ===
                    this.languageToDelete
                ) {
                    this.languagesAnswerSet[i].selected = true;
                    this.languageToDelete = 0;
                    break;
                }
            }
        },
        deleteLanguageConfirmed() {
            //Hay que borrar en el arreglo languageAnswers todos los objetos con idiomaid = languageID.
            //Después, hay que volver a generar el arreglo answerTable y el arreglo answerHeader:
            this.bDlgDeletingLanguage = false;

            var i;
            var j = 0;
            var iLength = this.languageAnswers.length;
            //console.log('languageAnswers = ', this.languageAnswers);

            for (i = 0; i < iLength; i++) {
                //console.log('i = ', i);
                //console.log('languageAnswers[i] = ',this.languageAnswers[i].respuesta);
                if (
                    this.languageAnswers[i].idiomaid === this.languageToDelete
                ) {
                    this.languageAnswers.splice(i, 1);
                    i--;
                    iLength--;
                }
                //console.log('languageAnswers = ', this.languageAnswers);
            }
            this.$store.dispatch('createAnswerSetLanguages');
        },
        cancelAddLanguage() {
            this.bDlgAddingLanguage = false;
            //Vuelve a desseleccionar el lenguage seleccionado:

            var i;
            for (i = 0; i < this.languagesAnswerSet.length; i++) {
                if (
                    this.languagesAnswerSet[i].languageID === this.languageToAdd
                ) {
                    this.languagesAnswerSet[i].selected = false;
                    this.languageToAdd = 0;
                    break;
                }
            }
        },
        addLanguageConfirmed() {
            //Hay que agregar un objeto languageAnswers con el idioma seleccionado para cada respuesta existente
            //del set de respuestas.

            //Después, hay que volver a generar el arreglo answerTable y el arreglo answerHeader.
            this.bDlgAddingLanguage = false;

            //console.log('languageAnswers = ', this.languageAnswers);

            //Si todavía no hay ninguna respuesta, se crea una automáticamente y se abre el modal para su edición:
            var bEditNewAnswer = false;
            if (this.answers.length === 0) {
                bEditNewAnswer = true;

                var answer = {
                    valoressetrespuestasid: -1,
                    setrespuestasid: this.answerSetID,
                    valor: 0,
                };

                this.answers.push(answer);
                this.selectedAnswerNumber = this.answers.length;

                //Crea un objeto para el arreglo de elementos seleccionados de la tabla:
                var newSelectedAnswer = {
                    valor: answer.valor,
                    valoressetrespuestasid: answer.valoressetrespuestasid,
                    num: this.selectedAnswerNumber,
                };

                const idiomaid = this.languageToAdd;
                newSelectedAnswer[idiomaid] = '';
            }

            var i;
            for (i = 0; i < this.answers.length; i++) {
                const languageAnswer = {
                    valoressetrespuestasid: this.answers[i]
                        .valoressetrespuestasid,
                    idiomaid: this.languageToAdd,
                    respuesta: '',
                };

                this.languageAnswers.push(languageAnswer);
            }

            //console.log('languageAnswers = ', this.languageAnswers);
            this.$store.dispatch('createAnswerSetLanguages');

            //Si no había todavía ninguna respuesta, automáticamente se creó una, y se abre el modal para su edición:
            if (bEditNewAnswer) {
                //Se selecciona la respuesta que se acaba de agregar y se llama a onEditAnswer() para su edición:
                this.selectedAnswer.push(newSelectedAnswer);
                this.onEditAnswer();
            }
        },
        onNewAnswer() {
            //Checa si hay por lo menos un idioma seleccionado:
            var i;
            var bLanguage = false;
            for (i = 0; i < this.languagesAnswerSet.length; i++) {
                if (this.languagesAnswerSet[i].selected) {
                    bLanguage = true;
                    break;
                }
            }

            if (bLanguage) {
                //Hay por lo menos un idioma seleccionado:
                this.selectedAnswerValue = 0;
                this.selectedAnswerID = 0;
                this.selectedAnswer = [];
                console.log('selectedAnswer = ', this.selectedAnswer);

                //Obtiene el número de la nueva respuesta, sumando uno al número de respuestas actuales:
                this.selectedAnswerNumber = this.answers.length + 1;

                //Se obtiene un ID temporal, el cual será negativo, para diferenciarlo de los IDs de las respuestas ya guardadas
                //en la BD del servidor. Se deben buscar todos los IDs negativos actuales y al más negativo hay que restarle uno:

                var newID = -1;
                for (i = 0; i < this.answers.length; i++) {
                    if (this.answers[i].valoressetrespuestasid <= newID) {
                        newID--;
                    }
                }
                this.selectedAnswerID = newID;

                this.editingAnswer = [];

                //Crea un nuevo objeto para el arreglo answers:
                var newAnswer = {
                    valoressetrespuestasid: this.selectedAnswerID,
                    setrespuestasid: this.answerSetID,
                    valor: 0,
                };
                this.answers.push(newAnswer);

                //Crea un objeto para el arreglo de elementos seleccionados de la tabla (que sólo tiene un arreglo):
                var newSelectedAnswer = {
                    valor: this.selectedAnswerValue,
                    valoressetrespuestasid: this.selectedAnswerID,
                    num: this.selectedAnswerNumber,
                };

                //Crea un objeto nuevo para el arreglo languageAnswers por cada idioma registrado:
                for (i = 0; i < this.languagesAnswerSet.length; i++) {
                    if (this.languagesAnswerSet[i].selected) {
                        var languageAnswer = {
                            valoressetrespuestasid: this.selectedAnswerID,
                            idiomaid: this.languagesAnswerSet[i].languageID,
                            respuesta: '',
                        };
                        this.languageAnswers.push(languageAnswer);

                        //Crea un objeto para el arreglo de elementos seleccionados de la tabla:
                        const idiomaid = this.languagesAnswerSet[i].languageID;
                        newSelectedAnswer[idiomaid] = '';
                    }
                }
                this.$store.dispatch('createAnswerSetLanguages');

                //Se selecciona la respuesta que se acaba de agregar y se llama a onEditAnswer() para su edición:
                this.selectedAnswer.push(newSelectedAnswer);

                this.onEditAnswer();
            } //No hay ningún idioma seleccionado...
            else {
                this.bDlgNoLanguageWarning = true;
            }
        },

        onEditAnswer() {
            console.log('selectedAnswer = ', this.selectedAnswer);
            console.log('selectedAnswer[0].valor = ', this.selectedAnswer[0].valor);

            this.selectedAnswerValue = this.selectedAnswer[0].valor;
            this.selectedAnswerID = this.selectedAnswer[0].valoressetrespuestasid;
            this.selectedAnswerNumber = this.selectedAnswer[0].num;

            //Se crea el arreglo editingAnswer con los objetos del arreglo languageAnswers que tengan
            //id = id de la respuesta seleccionada:

            //console.log('selectedAnswer = ', this.selectedAnswer);

            this.editingAnswer = [];
            var i;
            for (i = 0; i < this.languageAnswers.length; i++) {
                if (this.languageAnswers[i].valoressetrespuestasid === this.selectedAnswerID)
                {
                    var answer = {
                        valoressetrespuestasid: this.selectedAnswerID,
                        languageID: this.languageAnswers[i].idiomaid,
                        answerLanguageName: '',
                        respuesta: this.languageAnswers[i].respuesta,
                        tooltipLanguageName: '',
                        tooltip: this.languageAnswers[i].tooltip,
                    };

                    var j;
                    for (j = 0; j < this.languages.length; j++) {
                        if (this.languages[j].idiomaid === answer.languageID) {
                            answer.answerLanguageName = "Respuesta en " + this.languages[j].idioma;
                            answer.tooltipLanguageName = "Tooltip en " + this.languages[j].idioma;
                            break;
                        }
                    }
                    this.editingAnswer.push(answer);
                }
            }
            this.bDlgEditAnswer = true;
        },
        onConfirmAnswerEdition() {
            //Actualiza todos los registros de languageAnswers con ID igual al
            //ID de la respuesta seleccionada con los valores del arreglo editingAnswer.

            var i;
            for (i = 0; i < this.editingAnswer.length; i++) {
                var j;
                for (j = 0; j < this.languageAnswers.length; j++) {
                    if (this.languageAnswers[j].valoressetrespuestasid === this.editingAnswer[i].valoressetrespuestasid &&
                        this.languageAnswers[j].idiomaid === this.editingAnswer[i].languageID)
                    {
                        this.languageAnswers[j].respuesta = this.editingAnswer[i].respuesta;
                        this.languageAnswers[j].tooltip = this.editingAnswer[i].tooltip;
                        break;
                    }
                }
            }

            //Actualiza el valor de la respuesta:
            for (i = 0; i < this.answers.length; i++) {
                if (this.answers[i].valoressetrespuestasid === this.selectedAnswerID)
                {
                    this.answers[i].valor = this.selectedAnswerValue;
                    break;
                }
            }

            this.bDlgEditAnswer = false;
            this.$store.dispatch('createAnswerSetLanguages');

            //La siguiente linea se. tuvo que agregar porque por alguna razón, cuando se edita una respuesta que se acaba de agregar,
            //el valor de this.selectedAnswer[0].valor se resetea al valor inicial (cero):
            this.selectedAnswer[0].valor = this.selectedAnswerValue;
        },
        onCancelAnswerEdition() {
            this.bDlgEditAnswer = false;
        },
        onDeleteAnswer() {
            this.selectedAnswerID = this.selectedAnswer[0].valoressetrespuestasid;
            this.selectedAnswerNumber = this.selectedAnswer[0].num;
            this.bDeletingAnswer = true;
        },
        cancelDeleteAnswer() {
            this.bDeletingAnswer = false;
        },
        deleteAnswerConfirmed() {
            //Busca la respuesta en el arreglo answer y en languageAnswers y la borra:
            var bFound = false;
            var i;
            console.log('this.selectedAnswerID = ', this.selectedAnswerID);
            console.log('this.answers = ', this.answers);
            console.log('this.languageAnswers = ', this.languageAnswers);
            for (i = 0; i < this.answers.length; i++) {
                if (
                    this.answers[i].valoressetrespuestasid ===
                    this.selectedAnswerID
                ) {
                    this.answers.splice(i, 1);
                    break;
                }
            }

            for (i = 0; i < this.languageAnswers.length; i++) {
                if (
                    this.languageAnswers[i].valoressetrespuestasid ===
                    this.selectedAnswerID
                ) {
                    this.languageAnswers.splice(i, 1);
                    i--;
                    6;
                }
            }
            this.$store.dispatch('createAnswerSetLanguages');
            this.bDeletingAnswer = false;
        },

        onSearch() {
            if (this.searchText != '') {
                //Se convierte el texto a minúsculas para hacer la comparación:

                var searchTextLowerCase = this.searchText.toLowerCase();

                var i;
                var bFound = false;
                for (i = 0; i < this.answerSets.length; i++) {
                    var strLowerCaseText = this.answerSets[
                        i
                    ].nombre.toLowerCase();
                    if (strLowerCaseText.indexOf(searchTextLowerCase) === 0) {
                        this.selectedAnswerSetIndex = i;
                        this.selectAnswerSet(
                            this.answerSets[i].setrespuestasid
                        );
                        bFound = true;
                        break;
                    }
                }
                if (!bFound) {
                    this.bShowNotFoundAlert = true;
                }
                this.searchText = '';
            }
        },
    },
    computed: {
        ...mapGetters([
            'answerSets',
            'answerTable',
            'answerTableHeader',
            'waitCursor',
            'languages',
        ]),
        selectedAnswerSetIndex: {
            get() {
                return this.$store.getters.selectedAnswerSetIndex;
            },
            set(selectedAnswerSetIndex) {
                this.$store.dispatch(
                    'updateSelectedAnswerSetIndex',
                    selectedAnswerSetIndex
                );
            },
        },
        languagesAnswerSet: {
            get() {
                return this.$store.getters.languagesAnswerSet;
            },
            set(languagesAnswerSet) {
                this.$store.dispatch(
                    'updateLanguagesAnswerSet',
                    languagesAnswerSet
                );
            },
        },

        languageAnswers: {
            get() {
                return this.$store.getters.languageAnswers;
            },
            set(languageAnswers) {
                this.$store.dispatch('updateLanguageAnswers', languageAnswers);
            },
        },

        answers: {
            get() {
                return this.$store.getters.answers;
            },
            set(answers) {
                this.$store.dispatch('updateAnswers', answers);
            },
        },

        listHeight() {
            var height;
            if (this.$vuetify.breakpoint.xs) {
                height = '200px';
            } else if (this.$vuetify.breakpoint.sm) {
                height = '700px';
            } else {
                height = '470px';
            }
            return height;
        },

        errorModalWidth() {
            var width = '100%';
            if (this.$vuetify.breakpoint.xs) {
                width = '70%';
            } else if (this.$vuetify.breakpoint.sm) {
                width = '50%';
            } else if (this.$vuetify.breakpoint.md) {
                width = '40%';
            } else if (this.$vuetify.breakpoint.lg) {
                width = '30%';
            } else if (this.$vuetify.breakpoint.xl) {
                width = '20%';
            }
            return width;
        },
    },
};
</script>

<style scoped>
.sub-window {
    background: rgba(224, 224, 224, 0.6);
}
.answersets {
    background: url('../assets/alex-kotliarskyi-QBpZGqEMsKg-unsplash.jpg');
    background-size: cover;
    width: 100%;
    height: 100%;
}

.my-list-title {
    font-size: 15px;
    font-weight: bold;
}
.my-list-subtitle {
    font-size: 13px;
    font-weight: bold;
}
.my-list-header {
    font-size: 11px;
    font-weight: bold;
    background-color: #e0e0e0;
}
.my-list-item {
    min-height: 30px !important;
}

/* ***************Modificaciones para que no se parta el texto en v-card-text y en v-card-title (al parecer es un bug de vuetify):************* */
.v-card__text,
.v-card__title {
    word-break: normal; /* maybe !important  */
}
</style>